














import { Component, Prop, Vue} from 'vue-property-decorator';
import Map from '@arcgis/core/Map';
import MapView from '@arcgis/core/views/MapView';
import FeatureLayer from '@arcgis/core/layers/FeatureLayer';
import MapImageLayer from '@arcgis/core/layers/MapImageLayer';
import VectorTileLayer from '@arcgis/core/layers/VectorTileLayer';
import TileLayer from '@arcgis/core/layers/TileLayer';
import Basemap from '@arcgis/core/Basemap';
import * as watchUtils from '@arcgis/core/core/watchUtils';
import '@arcgis/core/assets/esri/themes/light/main.css';

@Component
export default class EsriMapHeatmap extends Vue {

    public isLoading: boolean = true;

    get leftDrawerOpen(): boolean {
        return this.$store.state.leftDrawerOpen;
    }

    get map(): __esri.Map {
        return this.$store.state.map;
    }

    get mapView(): __esri.MapView {
        return this.$store.state.mapView;
    }

    get basemaps() {
        return this.$store.state.basemaps;
    }

    public createMap() {
        let activeBasemap = 'gray-vector';
        this.basemaps.forEach((item: any, index: number) => {
            if (item.active === true) {
                activeBasemap = item.url;
            }
        });

        const eMap: __esri.Map = new Map({
            basemap: activeBasemap,
            layers: [],
        });
        this.$store.dispatch('setMap', eMap);

        const view: __esri.MapView = new MapView({
            container: 'viewDiv',
            map: eMap,
            center: [-63.5268027, 44.982321],
            zoom: 7,
            popup: {
                actions: [], // remove zoom-to
                dockEnabled: true, // dock handled in vue components
                dockOptions: {
                    buttonEnabled: false,
                },
            },
        });
        view.ui.move(['zoom'], 'bottom-right');
        view.padding.left = 12;
        view.padding.right = 12;
        view.padding.top = 157;
        this.$store.dispatch('setMapView', view);

        watchUtils.whenTrue(view, 'updating', (evt) => {
            this.isLoading = true;
        });
        watchUtils.whenFalse(view, 'updating', (evt) => {
            this.isLoading = false;
        });

        this.createLayers();
    }

    public async fullFeatureQuery(layer: __esri.FeatureLayer, point: __esri.Point) {
        const query = layer.createQuery();
        query.geometry = point;
        const results = await layer.queryFeatures(query).then(async (res: __esri.FeatureSet) => {
            return res;
        });
        return results;
    }

    public createLayers() {
        const layerList: __esri.Layer[] = [];

        this.$store.state.layers.forEach((item: any, index: number) => {
            if (item.type === 'FeatureLayer') {
                const fLayer: __esri.FeatureLayer = new FeatureLayer({
                    url: item.url,
                    visible: item.active,
                    title: item.name,
                });
                if (item.hasOwnProperty('minScale')) {
                    fLayer.minScale = item.minScale;
                }
                if (item.hasOwnProperty('renderer')) {
                    fLayer.renderer = item.renderer;
                }
                if (item.hasOwnProperty('outFields')) {
                    fLayer.outFields = item.outFields;
                }
                // if (item.hasOwnProperty('labelsVisible')) {
                //     fLayer.labelsVisible = item.labelsVisible;
                // }

                layerList.unshift(fLayer);
                if (item.hasOwnProperty('vectorLayer')) {
                    const extraLayer: __esri.VectorTileLayer = new VectorTileLayer({
                        url: item.vectorLayer,
                        visible: item.active,
                        title: item.name + '_vector',
                    });
                    if (item.hasOwnProperty('vectorStyle')) {
                        extraLayer.style = item.vectorStyle;
                    }
                    layerList.unshift(extraLayer);
                }
            } else if (item.type === 'MapImageLayer') {
                const miLayer: __esri.MapImageLayer = new MapImageLayer({
                    url: item.url,
                    visible: item.active,
                    title: item.name,
                    // sublayers: item.visibleSubLayers,
                });
                layerList.unshift(miLayer);
            } else if (item.type === 'VectorTileLayer') {
                const vLayer: __esri.VectorTileLayer = new VectorTileLayer({
                    url: item.url,
                    visible: item.active,
                    title: item.name,
                });
                layerList.unshift(vLayer);
            }
        });

        // for any non-esri basemap we need to construct it from the url first
        for (const basemap of this.basemaps) {
            if (basemap.url.startsWith('http')) {
                const tileLayer = new TileLayer({
                    url: basemap.url,
                });
                const basemapLayer = new Basemap({
                    baseLayers: [tileLayer],
                    title: basemap.name,
                });
                basemap.url = basemapLayer;
            }
        }

        const watchHandle = this.mapView.on('layerview-create', (event) => {
            console.log('Layer rendered');
            console.log(event);
            watchHandle.remove();
            this.updateAttribution();
            this.$store.dispatch('initHeatmap');
        });
        this.map.layers.addMany(layerList);
    }

    public updateAttribution() {
        // This needs to happen afer the map has loaded
        const poweredBy = document.querySelector('.esri-attribution__powered-by') as Element;
        poweredBy.innerHTML += ' | Built by <a href="https://www.mapdev.ca" target="_blank">MapDev</a>';
    }

    public mounted() {
        this.createMap();
    }

    public beforeDestroy() {
        console.log('map: beforeDestroy');
    }
}
